<div>Password Requirements:</div>
<ul>
	<li>At least 8 characters.</li>
	<li>Contains at least 1 number</li>
	<li>Contains at least 1 special character</li>
	<li>Contains at least 1 uppercase letter</li>
	<li>Contains at least 1 lowercase letter</li>
</ul>
